import React from 'react';

import { useTranslation } from 'react-i18next';
import moment from 'moment';
import Tooltip from '../../components/Tooltip';

import { formatCurrency } from '../currencyMask';
import { sumArray } from '../sumDollarAmounts';

function DateIcon({ payment /* index, scheduledPayments */ }) {
  const { t } = useTranslation();

  return (
    <React.Fragment key={payment.id}>
      <div className="flex items-center gap-1">
        <strong>{t('common.Scheduled')}:</strong>
        <span>
          {moment(payment.date).format('MM/DD/YYYY')}
          {/*  <svg
            className="w-4 inline mr-1 relative -top-0.5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
            <circle cx="14" cy="14" r="4" />
            <polyline points="14 12 14 14 16 14" />
          </svg> */}
        </span>
        <div className="ml-1">
          <Tooltip>
            {t('common.Amount')}: $
            {formatCurrency(
              sumArray([payment.amount, payment.amount_to_principal])
            )}
          </Tooltip>
        </div>
      </div>
      {/*   {index !== scheduledPayments.length - 1 ? ', ' : ''} */}
      {/* <br /> */}
    </React.Fragment>
  );
}

export default function createInvoiceScheduleTableCell(scheduledPayments) {
  if (!scheduledPayments || !scheduledPayments.length) {
    return '';
  }

  if (scheduledPayments.length === 1) {
    return (
      <DateIcon
        payment={scheduledPayments[0]}
        index={0}
        scheduledPayments={scheduledPayments}
      />
    );
  }

  // a comma separated list of the date and amount ($)
  const list = scheduledPayments.map((payment, index) => (
    <DateIcon
      key={payment.id}
      payment={payment}
      index={index}
      scheduledPayments={scheduledPayments}
    />
  ));

  return list;
}
